import React from 'react';
import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';

import useAnalyticsConnectExplore from './useAnalyticsConnectExplore';
import CardList from './cardList';
import AppSearchField from './appSearchField';

function AnalyticsConnectExplore() {
  const {
    integrationApps,
    searchApp,
  } = useAnalyticsConnectExplore();

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
        <Box>
          <Box component="h2" style={{ margin: '0 0 6px', fontSize: '20px', fontWeight: 700 }}>
            Browse integrations, ready to go
          </Box>
          <Box component="p" style={{ margin: 0, fontSize: '14px', color: '#666' }}>
            Need a custom integration? You can place a request via the ECAL Support agent.
          </Box>
        </Box>
        <AppSearchField
          onSearch={(searchText) => searchApp(searchText) }
        />
      </Box>
      <CardList cardListData={integrationApps} />
    </React.Fragment>
  );
}

const AnalyticsConnectExploreObserver = observer(AnalyticsConnectExplore);
export default AnalyticsConnectExploreObserver;
